// Generated by ReScript, PLEASE EDIT WITH CARE

import * as TicketingOrderLogs from "../../../../to-be-migrated/domain/types/order/TicketingOrderLogs.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";

function execute(order_logs_json) {
  return DeccoUtils$Catalyst.resolveResult(TicketingOrderLogs.t_decode(order_logs_json), "OrderLogsEntityMapper.re - unable to decode json ");
}

export {
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
